import { render, staticRenderFns } from "./WhatsappProviderTariff.vue?vue&type=template&id=6590fc26&"
import script from "./WhatsappProviderTariff.vue?vue&type=script&lang=ts&"
export * from "./WhatsappProviderTariff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports